import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './view/LoginPage';
import { ToastContainer } from 'react-toastify';
import Dashboard from './view/Dashboard';

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/unauthorised" element={<LoginPage />} />
            {/* Use a wildcard `*` for nested routing in Dashboard */}
            <Route path="/dashboard/*" element={<Dashboard />} />
          </Routes>
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
